import * as types from './Types.js';

export function findLiquidacoesPagar(filter) {
  return ({ fetch }) => ({
    type: types.PAGAR_LIST,
    payload: {
      promise: fetch(`/api/liquidacoes/pagar?${filter}`)
    }
  });
}

export function findTotalLiquidacoesPagar(filter) {
  return ({ fetch }) => ({
    type: types.TOTAL_PAGAR,
    payload: {
      promise: fetch(`/api/liquidacoes/pagar/total?${filter}`)
    }
  });
}

export function findLiquidacoesPagas(filter) {
  return ({ fetch }) => ({
    type: types.PAGAS_LIST,
    payload: {
      promise: fetch(`/api/liquidacoes/pagas?${filter}`)
    }
  });
}

export function findTotalLiquidacoesPagas(filter) {
  return ({ fetch }) => ({
    type: types.TOTAL_PAGAS,
    payload: {
      promise: fetch(`/api/liquidacoes/pagas/total?${filter}`)
    }
  });
}

export function findFonteRecurso(filter) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAFONTERECURSO,
    payload: {
      promise: fetch(`/api/programatica/fonteRecurso?${filter}`)
    }
  });
}
